<!-- Zone mode -->

<div class="uploader-wrapper upload-zone" *ngIf="type === 'zone'">
    <div *ngIf="uploading" [id]="'errorRendererId'">
        <ng-container [ngTemplateOutlet]="loadingRenderer?loadingRenderer.templateRef:loading"></ng-container>
    </div>
    <div class="uploader-label" *ngIf="!preview && !uploading">
        <i *ngIf="icon" [class]="icon"></i>
        <img *ngIf="iconSrc" [src]="iconSrc">
        {{ label }}
    </div>
    <div class="uploader-preview" *ngIf="preview"
         [style.background-image]="'url(' + preview + ')'"
         [style.background-size]="backgroundSize"
    ></div>

    <input
        #inputFile
        type="file"
        class="uploader-input"
        [name]="name"
        [required]="required"
        [disabled]="disabled"
        [accept]="types.join(',')"
        (change)="onSelectFile($event)"
    />
</div>

<!-- Button mode  -->

<div class="uploader-wrapper" *ngIf="type !== 'zone'">
    <div class="uploader-label">
        {{ uploading ? '' : label }}
        <div *ngIf="uploading" [id]="'loadingRendererId'">
            <ng-container [ngTemplateOutlet]="loadingRenderer?loadingRenderer.templateRef:loading"
                          [ngTemplateOutletContext]="{message:''}"></ng-container>
        </div>
    </div>

    <input
        #inputFile
        type="file"
        class="uploader-input"
        [name]="name"
        [required]="required"
        [disabled]="disabled"
        [accept]="types.join(',')"
        (change)="onSelectFile($event)"
    />
</div>

<ng-template #loading let-message="message">
    <app-loading [message]="message"></app-loading>
</ng-template>
